export default __webpack_public_path__ + "static/media/coodash_bg.ce1c091e.mp4";